var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39418 3.14332C8.17898 2.95223 7.82102 2.95223 7.60582 3.14332L4.15394 6.2085C3.81953 6.50545 4.06583 7 4.54812 7L11.4519 7C11.9342 7 12.1805 6.50545 11.8461 6.2085L8.39418 3.14332ZM7.60582 12.8567C7.82103 13.0478 8.17898 13.0478 8.39418 12.8567L11.8461 9.7915C12.1805 9.49455 11.9342 9 11.4519 9L4.54812 9C4.06583 9 3.81953 9.49455 4.15394 9.7915L7.60582 12.8567Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.39edfb0c7baf5b6944f3591acae0a09e.svg";
export { ForwardRef as ReactComponent };